import { useEffect, useState } from 'react';

// Approached asymptotically, so the bar always moves but never "finishes"
// ahead of the job it stands in for.
const CEILING = 95;
const TICK_MS = 500;

/**
 * A progress value for work whose backend reports no progress of its own.
 *
 * @param {boolean} isRunning - Resets to 0 whenever this goes false
 */
const useFakeProgress = (isRunning) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (!isRunning) {
            setProgress(0);
            return;
        }
        const interval = setInterval(() => {
            setProgress((prev) => (prev >= CEILING ? prev : prev + Math.max((CEILING - prev) * 0.03, 0.2)));
        }, TICK_MS);
        return () => clearInterval(interval);
    }, [isRunning]);

    return progress;
};

export default useFakeProgress;
